import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=fcdc2f1e&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=fcdc2f1e&prod&scoped=true&lang=css"
import style1 from "./PieChart.vue?vue&type=style&index=1&id=fcdc2f1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdc2f1e",
  null
  
)

export default component.exports